// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.864 6.672c1.107 1.106 1.286 2.817.329 3.906l-.111.119-5.385 5.385c-1.041 1.041-2.75.939-3.9-.099l-.125-.119-2.15-2.15 1.413-1.415 2.151 2.15c.382.383.873.451 1.136.269l.06-.05 5.386-5.386c.223-.223.202-.7-.129-1.099l-.089-.097-3.535-3.536c-.383-.382-.873-.45-1.136-.268l-.061.05-1.991 1.992-1.415-1.414 1.992-1.992c1.041-1.041 2.75-.939 3.9.099l.125.119zM14.186 9.58l-1.414 1.414-2.15-2.15c-.383-.383-.873-.451-1.136-.27l-.061.052L4.04 14.01c-.223.223-.202.7.129 1.099l.089.097 3.535 3.536c.383.382.873.45 1.136.268l.06-.05 1.992-1.992 1.414 1.414-1.99 1.991c-1.042 1.042-2.75.94-3.9-.098l-.126-.12-3.536-3.535c-1.106-1.106-1.285-2.817-.328-3.906l.11-.119 5.386-5.385c1.041-1.041 2.75-.939 3.9.099l.125.119z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsLink;
